import * as React from 'react';
import ProductRating from 'PyzShopUi/scripts/shop-ui/components/product-item/ProductRating';
import {PARAM_RATING} from 'PyzShopUi/scripts/product-review/constants';
import {ISetRatingPayload, setRating} from 'PyzShopUi/scripts/product-review/actions/rating';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

interface IStarItemProps {
    averageRating: number;
    reviewCount: number;
    isActive: boolean;
    totalReviewCount?: number;
    isLinkShownFull?: boolean;

    onClick(): void;

    dispatch: React.Dispatch<any>;
}

const StarItem: React.FunctionComponent<IStarItemProps> = props => {
    const { averageRating, reviewCount, isActive, isLinkShownFull, onClick, dispatch } = props;
    const { translate } = useTranslationHook();

    const displayTotalReview = () => {
        let reviewLink = `${reviewCount}`;
        if (isLinkShownFull) {
            const reviewText = translate('review', { count: reviewCount, ns: 'article-detail' });

            reviewLink = `${reviewCount} ${reviewText}`;
            return (<>
                <span className='total-review-link'>{`${reviewLink}`}</span>
            </>);
        }
        const onClick = () => {
            const selectedApiQueryData: ISetRatingPayload = isActive ? {} : {
                [PARAM_RATING]: averageRating
            };

            dispatch(setRating(selectedApiQueryData));
        };

        return (
            <>
                <span 
                    className={`${isActive ? 'total-review-link bold' : 'total-review-link'}`} 
                    onClick={onClick}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onClick()
                        }
                    }}
                    role="button"
                    tabIndex={0}
                >
                    {`${reviewLink}`}
                </span> 
                {isActive && <i className="icon icon-check"></i>}
            </>
        );
    }

    return (
        <div className="total-review-rating__star-item">
            <ProductRating ratingAverage={averageRating}/> <span className="division">|</span> {displayTotalReview()}
        </div>
    );
};

StarItem.defaultProps = {
    isLinkShownFull: true,
    isActive: false,
};

export default StarItem;
